import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, input, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { CountryListStandaloneComponent, ICountry } from 'ngx-countries-dropdown';

@Component({
  selector: 'app-country-list-dropdown',
  imports: [CommonModule, ReactiveFormsModule, CountryListStandaloneComponent],
  templateUrl: './country-list-dropdown.component.html',
  styleUrl: './country-list-dropdown.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryListDropdownComponent),
      multi: true
    }
  ]
})
export class CountryListDropdownComponent {
/** Lista completa de códigos de países */
  allCountryCodes: string[] = [
    'af','ax','al','dz','as','ad','ao','ai','aq','ag','ar','am','aw','au','at','az',
    'bs','bh','bd','bb','by','be','bz','bj','bm','bt','bo','bq','ba','bw','bv','br',
    'io','bn','bg','bf','bi','kh','cm','ca','cv','ky','cf','td','cl','cn','cx','cc',
    'co','km','cg','cd','ck','cr','ci','hr','cu','cw','cy','cz','dk','dj','dm','do',
    'ec','eg','sv','gq','er','ee','sz','et','fk','fo','fj','fi','fr','gf','pf','tf',
    'ga','gm','ge','de','gh','gi','gr','gl','gd','gp','gu','gt','gg','gn','gw','gy',
    'ht','hm','va','hn','hk','hu','is','in','id','ir','iq','ie','im','il','it','jm',
    'jp','je','jo','kz','ke','ki','kp','kr','kw','kg','la','lv','lb','ls','lr','ly',
    'li','lt','lu','mo','mg','mw','my','mv','ml','mt','mh','mq','mr','mu','yt','mx',
    'fm','md','mc','mn','me','ms','ma','mz','mm','na','nr','np','nl','nc','nz','ni',
    'ne','ng','nu','nf','mk','mp','no','om','pk','pw','ps','pa','pg','py','pe','ph',
    'pn','pl','pt','pr','qa','re','ro','ru','rw','bl','sh','kn','lc','mf','pm','vc',
    'ws','sm','st','sa','sn','rs','sc','sl','sg','sx','sk','si','sb','so','za','gs',
    'ss','es','lk','sd','sr','sj','se','ch','sy','tw','tj','tz','th','tl','tg','tk',
    'to','tt','tn','tr','tm','tc','tv','ug','ua','ae','gb','us','um','uy','uz','vu',
    've','vn','vg','vi','wf','eh','ye','zm','zw'
  ];

  /** Valor actual: todo el objeto del país */
  @Input() value: string | null = null;
  @Output() countryChange = new EventEmitter<ICountry>();
  code: any = input();
  disabled = input();

  // ControlValueAccessor
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: ICountry): void {
    //this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  handleChange(country: ICountry) {
    //this.value = country;
    this.onChange(country);
    this.onTouched();
    this.countryChange.emit(country);
  }
}